import Http from '../../http';

export const fetchStripeLink = async (ownerType, ownerId, returnUrl) => {
  const stripeHostedOnboardingInfo = await Http.get(`/onboarding/stripe/${ownerType}/${ownerId}/info`);
  const stripeLinkType = stripeHostedOnboardingInfo?.info?.link;

  if (stripeLinkType) {
    const linkResult = await Http.post(
      `/onboarding/stripe/${ownerType}/${ownerId}/link/${stripeLinkType}`,
      {
        returnUrl,
        refreshUrl: returnUrl,
      }
    );

    return linkResult?.url;
  }

  return null;
};
